import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
 
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { DescripcionContenidoPaqueteEdit } from "./edit";
const EditModal = DescripcionContenidoPaqueteEdit;
type Entity = models.DescripcionContenidoPaqueteDTO;
type Column = kea.Grid2Column<Entity>;

export interface Props {
    value: Entity[];
    idDescripcionPaquete: number;
    onChange: (value: Entity[]) => PromiseLike<void> | void;
    readonly?: boolean;
}

export interface BotonesDeps {
    onEliminar: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Eliminar",
            style: "danger",
            iconClass: fa("trash"),
            onClick: deps.onEliminar
        }
    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "300px"
            })
        })
    }
}

export const columnasFijas: Column[] = [
    { title: "Nombre contenido paquete", cell: x => ({ data: x.NombreContenidoPaquete }) },
];

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}

/**
* Listado de DescripcionContenidoPaqueteDTO
*/
class DescripcionContenidoPaqueteListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    /**Establece las descripciones de la fila */
    private setDescripciones = async (idDescripcionPaquete: number, idContenidoPaquete: number, contenidosPaquetes: models.ContenidoPaqueteDTO[]): Promise<Entity> => {
        const dirCol: models.DescripcionContenidoPaquete = {
            IdDescripcionPaquete: idDescripcionPaquete,
            IdContenidoPaquete: idContenidoPaquete
        };

        var contenidoPaquete = contenidosPaquetes.filter(x => x.IdRegistro == idContenidoPaquete)[0];
        return { ...dirCol, NombreContenidoPaquete: contenidoPaquete.Nombre };
    }

    onAgregar = async () => {
        var contenidosSeleccionados = this.props.value.map(x => x.IdContenidoPaquete);
        const result = await this.modals.showModal(EditModal, undefined, contenidosSeleccionados);
        if (result.result) {
            const idDescripcionPaquete = this.props.idDescripcionPaquete;
            var contenidosPaquetes = await resources.ContenidoPaquete.query();

            let data = await Promise.all(result.value.map(async (IdContenidoPaquete) => {
                const nuevo = await this.setDescripciones(idDescripcionPaquete, IdContenidoPaquete, contenidosPaquetes);
                return nuevo;
            }));
            await this.props.onChange(data);
        }
    }

    onEliminar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.NombreContenidoPaquete);
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Contenidos Paquetes" onAgregar={this.onAgregar} />
                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const DescripcionContenidoPaqueteList = kea.mapProps(componentToRx(DescripcionContenidoPaqueteListNoRx), x => ({ ...x, value: x.value || [] }));


// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/descripcionespaquete/edit/components/contenidospaquetes/list.tsx